import { Search } from '@mui/icons-material'
import QrCode2Icon from '@mui/icons-material/QrCode2'
import productRequest from 'assets/icons/svgs/productRequest.png'

const AssetDetailsStartIcon = ({
  isManualAddition,
  isProductRequest = false,
}: {
  isManualAddition: boolean
  isProductRequest?: boolean
}) => {
  if (isProductRequest) {
    return (
      <img
        src={productRequest}
        alt="product-request"
        width={35}
        height="auto"
      />
    )
  }
  return isManualAddition ? (
    <Search fontSize="large" />
  ) : (
    <QrCode2Icon fontSize="large" />
  )
}

export default AssetDetailsStartIcon
